export enum EditRecurringEventTypes {
  SelectedEvent = "selectedEvent",
  CurrentAndfollowingEvents = "currentAndfollowingEvents",
  AllEvents = "allEvents",
}
